'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackGtag = exports.trackObApi = exports.trackTtq = exports.trackSnaptr = exports.trackPintrk = exports.setMixAndMatchDataLayerItems = exports.setDataLayerItem = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _products = require('../services/products');

var _functional = require('./functional');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

/**
 * Helper for setting a GA4 GTM dataLayer item for tracking
 */
var setDataLayerItem = exports.setDataLayerItem = function setDataLayerItem(_ref) {
  var product = _ref.product,
      variant = _ref.variant,
      quantity = _ref.quantity,
      index = _ref.index,
      discountPercentage = _ref.discountPercentage;

  var price = void 0,
      discount = void 0;

  if (discountPercentage) {
    price = parseFloat(variant.price);
    discount = discountPercentage * price / 100;
    discount = discount.toFixed(2);
    discount = parseFloat(discount);
    price = price - discount;
  } else if (variant && variant.compare_at_price) {
    price = parseFloat(variant.price);
    discount = parseFloat(variant.compare_at_price) - parseFloat(variant.price);
    discount = discount.toFixed(2);
    discount = parseFloat(discount);
  } else {
    price = parseFloat(variant.price);
    discount = 0;
  }

  var data = {
    item_id: variant.sku,
    item_name: product.title,
    affiliation: window.theme && window.theme.affiliation,
    currency: window.theme && window.theme.currency,
    item_brand: product.vendor,
    item_category: product.product_type,
    price: price,
    quantity: quantity
  };

  if (discount > 0) {
    data.discount = discount;
  }

  if (variant.title && variant.title !== 'Default Title') {
    data.item_variant = variant.title;
  }

  if (index !== undefined) {
    data.index = index;
  }

  return {
    value: price * quantity,
    item: data
  };
};

var setMixAndMatchDataLayerItems = exports.setMixAndMatchDataLayerItems = function () {
  var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(_ref3) {
    var items = _ref3.items,
        discountPercentage = _ref3.discountPercentage;
    var val, its;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            val = 0;
            _context2.next = 3;
            return _promise2.default.all(items.map(function () {
              var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(item) {
                var product, variant;
                return _regenerator2.default.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return (0, _products.getProductByHandle)(item.handle);

                      case 2:
                        product = _context.sent;
                        variant = product.variants.find(function (variant) {
                          return variant.id === item.id;
                        });
                        return _context.abrupt('return', setDataLayerItem({ product: product, variant: variant, quantity: item.quantity, discountPercentage: discountPercentage }));

                      case 5:
                      case 'end':
                        return _context.stop();
                    }
                  }
                }, _callee, undefined);
              }));

              return function (_x2) {
                return _ref4.apply(this, arguments);
              };
            }()));

          case 3:
            items = _context2.sent;
            its = items.map(function (_ref5) {
              var value = _ref5.value,
                  item = _ref5.item;

              val += value;
              return item;
            });
            return _context2.abrupt('return', {
              value: parseFloat(val.toFixed(2)),
              items: its
            });

          case 6:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function setMixAndMatchDataLayerItems(_x) {
    return _ref2.apply(this, arguments);
  };
}();

/**
 * Wrapper for pinterest tracking, checks if the window
 * function is available before firing the tracking event
 *
 */
var trackPintrk = exports.trackPintrk = function trackPintrk() {
  var pintrk = window.pintrk;

  if (typeof pintrk === 'undefined') return false;

  pintrk.apply(undefined, arguments);
};

/**
 * Wrapper for Snapchat tracking, checks if the window
 * function is available before firing the tracking event
 *
 */
var trackSnaptr = exports.trackSnaptr = function trackSnaptr() {
  var snaptr = window.snaptr;

  if (typeof snaptr === 'undefined') return false;

  snaptr.apply(undefined, arguments);
};

/**
 * Wrapper for TikTok tracking, checks if the window
 * function is available before firing the tracking event
 *
 */
var trackTtq = exports.trackTtq = function trackTtq() {
  var ttq = window.ttq;

  if (typeof ttq === 'undefined') return false;

  ttq.track.apply(ttq, arguments);
};

/**
 * Wrapper for OutBrain tracking, checks if the window
 * function is available before firing the tracking event
 *
 */
var trackObApi = exports.trackObApi = function trackObApi() {
  var obApi = window.obApi;

  if (typeof obApi === 'undefined') return false;

  obApi.apply(undefined, arguments);
};

/**
 * Wrapper for gtag tracking, checks if the window
 * function is available before firing the tracking event
 *
 */
var trackGtag = exports.trackGtag = function trackGtag(_ref6, async) {
  var eventCategory = _ref6.eventCategory,
      eventAction = _ref6.eventAction,
      eventLabel = _ref6.eventLabel,
      eventValue = _ref6.eventValue,
      nonInteraction = _ref6.nonInteraction,
      _ref6$data = _ref6.data,
      data = _ref6$data === undefined ? {} : _ref6$data;

  var gtag = window.gtag;
  data = (0, _assign2.default)({}, data, {
    event_category: eventCategory,
    event_label: eventLabel,
    value: eventValue,
    non_interaction: nonInteraction
  });

  data = (0, _functional.removeKeys)(data, undefined);

  if (!async) {
    if (methodExists('gtag')) gtag('event', eventAction, data);
  } else {
    trackAsync('gtag', ['event', eventAction, data]);
  }
};

/**
 * Reserved for events that can fire before the method needed
 * to track the event is not available on page load
 *
 */
function trackAsync(trackingMethod, data) {
  var retries = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 5;

  var RETRY_DELAY = 1000;
  var times = 1;

  var track = setInterval(function () {
    if (times === retries) {
      clearInterval(track);
    } else if (methodExists(trackingMethod)) {
      var _window;

      (_window = window)[trackingMethod].apply(_window, (0, _toConsumableArray3.default)(data));
      clearInterval(track);
    } else {
      times++;
    }
  }, RETRY_DELAY);
}

/**
 * Checks if a window function is available
 *
 */
function methodExists(trackingMethod) {
  return typeof window[trackingMethod] !== 'undefined';
}